import { request } from '@/utils/request';

const dumpApi = {
  getAll() {
    return request({
      method: 'get',
      url: `/dump`,
      config: {
        responseType: 'blob',
      },
    });
  },
};

export default dumpApi;
